import type { ReactNode } from 'react';
import { Center } from '@astryxdesign/core/Center';
import { VStack } from '@astryxdesign/core/Layout';
import { Heading } from '@astryxdesign/core/Text';
import { Spinner } from '@astryxdesign/core/Spinner';

/** Branded first paint while the studio loads (name comes from the HTML shell). */
export function StudioSplash({ name, children }: { name?: string; children?: ReactNode }) {
  return (
    <Center minHeight="100dvh" padding={6}>
      <VStack gap={4} hAlign="center" maxWidth={420}>
        {name ? (
          <Heading level={1} justify="center">
            {name}
          </Heading>
        ) : null}
        {children ?? <Spinner size="lg" label="Загружаем студию" />}
      </VStack>
    </Center>
  );
}
